module.exports = __webpack_public_path__ + "static/media/fightcout-news-mobile.c2c5ca34.png";